package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.model.Post
import com.example.readingnotes.domain.repository.PostRepository
import com.example.readingnotes.util.Result

class LoadPostListUseCase(
    private val postRepository: PostRepository,
) {
    suspend operator fun invoke(
        page: Int = 1,
        pageSize: Int = 20,
    ): Result<List<Post>> = postRepository.getPosts(page, pageSize)
}
